import { $, $$ } from '@utils';

function init() {
  if (!$('[data-au-search-bar]')) return;

  searchBarSubmit();
  searchBarSubmitOnEnter();
}

//Send Datalayer
function searchBarSubmit() {
  $$('[data-au-search-bar-button]').forEach((searcher) => {
    searcher.addEventListener('click', function () {
      var input = searcher.parentNode.querySelector('[data-au-search-bar-float-input] input');
      if (input.value) {
        searchBarDataLayer(input);
      }
    });
  });
}

// Trigger search click on input enter
function searchBarSubmitOnEnter() {
  $$('[data-au-search-bar-float-input] input').forEach((input) => {
    input.addEventListener('keypress', function (event) {
      if (event.key === 'Enter') {
        event.preventDefault();
        if (input.value) {
          var button = input.closest('[data-au-search-bar]').querySelector('[data-au-search-bar-button]');
          button.click();
        }
      }
    });
  });
}

// Datalayer
function searchBarDataLayer(input) {
  var itemId = `${input.value}_buscar`;

  window.dataLayer.push({
    event: 'navigation',
    content_type: 'buscar',
    item_id: itemId,
  });
}

export default { init };
